var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { Icon } from "../icon";
import { getPillColor } from "./mixins/colors";
var PillIcon = function (_a) {
    var icon = _a.icon, color = _a.color, hollow = _a.hollow, flavour = _a.flavour, size = _a.size, rest = __rest(_a, ["icon", "color", "hollow", "flavour", "size"]);
    if (!icon)
        return null;
    if (typeof icon !== "string")
        return icon;
    return (React.createElement(Icon, __assign({ color: color || (hollow ? getPillColor("color", flavour) : "bright"), "data-testid": "pill-icon", height: size || "14px", width: size || "14px", name: icon }, rest)));
};
export default PillIcon;
